// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var Markdown = function (x) {
    return x;
};
var tsBridgeMarkdown = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("Markdown")("__brandMarkdown"));
    }
};
var writeMarkdown = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showMarkdown = Data_Show.showString;
var readMarkdown = Simple_JSON.readString;
var ordMarkdown = Data_Ord.ordString;
var newtypeMarkdown = {
    Coercible0: function () {
        return undefined;
    }
};
var makeMarkdown = Markdown;
var eqMarkdown = Data_Eq.eqString;
export {
    Markdown,
    makeMarkdown,
    unwrap,
    newtypeMarkdown,
    eqMarkdown,
    ordMarkdown,
    showMarkdown,
    readMarkdown,
    writeMarkdown,
    tsBridgeMarkdown
};
//# sourceMappingURL=index.js.map
